class Address {
  constructor(
    postalCode,
    prefecture,
    municipality,
    subAddress
  ) {
    if (!(typeof postalCode === 'string')) {
      throw new TypeError(`The type of 'postalCode' must be String. Actual: ${typeof postalCode}`)
    }
    if (!(typeof prefecture === 'string')) {
      throw new TypeError(`The type of 'prefecture' must be String. Actual: ${typeof prefecture}`)
    }
    if (!(typeof municipality === 'string')) {
      throw new TypeError(`The type of 'municipality' must be String. Actual: ${typeof municipality}`)
    }
    if (!(typeof subAddress === 'string')) {
      throw new TypeError(`The type of 'suAddress' must be String. Actual: ${typeof subAddress}`)
    }
    this.postalCode = postalCode
    this.prefecture = prefecture
    this.municipality = municipality
    this.subAddress = subAddress
  }

  toObject() {
    return {
      postalCode: this.postalCode,
      prefecture: this.prefecture,
      municipality: this.municipality,
      subAddress: this.subAddress
    }
  }

  fullAddress() {
    return this.prefecture + this.municipality + this.subAddress
  }

  hasPrefecture(prefecture) {
    if(!(typeof prefecture === "string")) {
      throw new TypeError(`The type of 'prefecture' must be String. Actual: ${typeof prefecture}`)
    }
    return (this.prefecture === prefecture)
  }

  updatePostalCode(postalCode) {
    if (!(typeof postalCode === "string")) {
      throw new TypeError(`The type of 'prefecture' must be String. Actual: ${typeof postalCode}`)
    }
    this.postalCode = postalCode
  }

  updatePrefecture(prefecture) {
    if(!(typeof prefecture === "string")) {
      throw new TypeError(`The type of 'prefecture' must be String. Actual: ${typeof prefecture}`)
    }
    this.prefecture = prefecture
  }

  updateMunicipalty(municipality) {
    if(!(typeof municipality === "string")) {
      throw new TypeError(`The type of 'municipality' must be String. Actual: ${typeof municipality}`)
    }
    this.municipality = municipality
  }

  updateSubAddress(subAddress) {
    if(!(typeof subAddress === "string")) {
      throw new TypeError(`The type of 'subAddress' must be String. Actual: ${typeof subAddress}`)
    }
    this.subAddress = subAddress
  }
}

export { Address }